(ns ui.color
  (:require
   [garden.color :as garden]
   [reagent.core :as r]))

(def theme-normal
  {::primary   {:default         "#9EDC55"
                :scale-1         "#ADDF72"                  ; -> scale-1 > use when button is hovered
                :scale-2         "#CEEDAA"                  ; -> scale-2 > use when button is in focus
                :text-on-color   "#38363B"
                :text-scale-1    "#38363B"
                :text-scale-2    "#6B6770"
                :border-on-color "#38363B"
                :border-scale-1  "#ADDF72"
                :border-scale-2  "#9EDC55"}

   ::secondary {:default         "#38363B"
                :scale-1         "#6B6770"
                :scale-2         "#9B9790"
                :text-on-color   "#EDECE7"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#EDECE7"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::danger    {:default         "#FF6D48"
                :scale-2         "#FA9378"
                :scale-1         "#FA9378"
                :text-on-color   "#38363B"
                :text-scale-1    "#38363B"
                :text-scale-2    "#38363B"
                :border-on-color "#FF6D48"
                :border-scale-1  "#FA9378"
                :border-scale-2  "#FA9378"}
   ::input     {:default         "#FFFFFF"
                :scale-1         "#FAFAFA"
                :scale-2         "#EAEAEA"
                :text-on-color   "#555555"
                :text-scale-1    "#444444"
                :text-scale-2    "#333333"
                :border-on-color "#555555"
                :border-scale-1  "#444444"
                :border-scale-2  "#333333"}
   ::warning   {:default         "#F5BD3E"
                :scale-1         "#F8CE6E"
                :scale-2         "#FADE9F"
                :text-on-color   "#666666"
                :text-scale-1    "#777777"
                :text-scale-2    "#888888"
                :border-on-color "#666666"
                :border-scale-1  "#777777"
                :border-scale-2  "#888888"}
   ::info      {:default         "#31B8C7"
                :scale-1         "#21A8B7"
                :scale-2         "#1198A7"
                :text-on-color   "#FFFFFF"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::dimmer    {:default "#00000062"
                :scale-1 "#00000052"
                :scale-2 "#00000042"}
   ::bg-1      {:default         "#FDFDFD"
                :scale-1         "#FDFDFD"
                :scale-2         "#DDDDDD"
                :text-on-color   "#555555"
                :text-scale-1    "#333333"
                :text-scale-2    "#111111"
                :border-on-color "#EEEEEE"
                :border-scale-1  "#AAAAAA"
                :border-scale-2  "#333333"}
   ::bg-2      {:default         "#F3F3F3"
                :scale-1         "#EAEAEA"
                :scale-2         "#DADADA"
                :text-on-color   "#38363B"
                :text-scale-1    "#58565B"
                :text-scale-2    "#78767B"
                :border-on-color "#58565B"
                :border-scale-1  "#6B6770"
                :border-scale-2  "#78767B"}
   ::disabled  {:default         "#DDDEDF"
                :scale-1         "#CDCECF"
                :scale-2         "#F8F8F8"
                :text-on-color   "#999999"
                :text-scale-1    "#B3B3B3"
                :text-scale-2    "#CCCCCC"
                :border-on-color "#999999"
                :border-scale-1  "#B3B3B3"
                :border-scale-2  "#CCCCCC"}})

(def theme-dark-mode
  {::primary   {:default         "#9EDC55"
                :scale-1         "#86D32B"
                :scale-2         "#6BA823"
                :text-on-color   "#38363B"
                :text-scale-1    "#38363B"
                :text-scale-2    "#38363B"
                :border-on-color "#38363B"
                :border-scale-1  "#38363B"
                :border-scale-2  "#38363B"}
   ::secondary {:default         "#CCCCCC"
                :scale-1         "#B3B3B3"
                :scale-2         "#999999"
                :text-on-color   "#333"
                :text-scale-1    "#FFF"
                :text-scale-2    "#FFF"
                :border-on-color "#333"
                :border-scale-1  "#FFF"
                :border-scale-2  "#FFF"}
   ::danger    {:default         "#FF6D48"
                :scale-1         "#FF967B"
                :scale-2         "#FFBEAE"
                :text-on-color   "#333333"
                :text-scale-1    "#555555"
                :text-scale-2    "#777777"
                :border-on-color "#FAFAFA"
                :border-scale-1  "#FDFDFD"
                :border-scale-2  "#777777"}
   ::warning   {:default         "#F5BD3E"
                :scale-1         "#F8CE6E"
                :scale-2         "#FADE9F"
                :text-on-color   "#333333"
                :text-scale-1    "#333333"
                :border-on-color "#333333"
                :border-scale-1  "#333333"
                :border-scale-2  "#333333"}
   ::info      {:default         "#31B8C7"
                :scale-1         "#21A8B7"
                :scale-2         "#1198A7"
                :text-on-color   "#000000"
                :text-scale-1    "#000000"
                :text-scale-2    "#000000"
                :border-on-color "#000000"
                :border-scale-1  "#000000"
                :border-scale-2  "#000000"}
   ::input     {:default         "#333333"
                :scale-1         "#666666"
                :scale-2         "#999999"
                :text-on-color   "#CCCCCC"
                :text-scale-1    "#DDDDDD"
                :text-scale-2    "#EEEEEE"
                :border-on-color "#CCCCCC"
                :border-scale-1  "#DDDDDD"
                :border-scale-2  "#EEEEEE"}
   ::bg-1      {:default         "#000000"
                :scale-1         "#1A1A1A"
                :scale-2         "#333333"
                :text-on-color   "#FFFFFF"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::bg-2      {:default         "#333333"
                :scale-1         "#4D4D4D"
                :scale-2         "#666666"
                :text-on-color   "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::dimmer    {:default "#FFFFFF62"
                :scale-1 "#FFFFFF42"
                :scale-2 "#FFFFFF22"}
   ::disabled  {:default         "#CDCECF"
                :scale-1         "#CDCECF"
                :scale-2         "#CDCECF"
                :text-on-color   "#969696"
                :text-scale-1    "#969696"
                :text-scale-2    "#969696"
                :border-on-color "#969696"
                :border-scale-1  "#969696"
                :border-scale-2  "#969696"}})


(def theme-high-contrast
  {::primary   {:default         "#8ABF4C"
                :scale-1         "#8ABF4C"
                :scale-2         "#8ABF4C"
                :text-on-color   "#646464"
                :text-scale-1    "#646464"
                :text-scale-2    "#646464"
                :border-on-color "#646464"
                :border-scale-1  "#646464"
                :border-scale-2  "#646464"}
   ::secondary {:default         "#CCC"
                :scale-1         "#AAA"
                :scale-2         "#888"
                :text-on-color   "#333"
                :text-scale-1    "#333"
                :text-scale-2    "#333"
                :border-on-color "#333"
                :border-scale-1  "#333"
                :border-scale-2  "#333"}
   ::danger    {:default         "#E86546"
                :scale-1         "#E86546"
                :scale-2         "#E86546"
                :text-on-color   "#FFFFFF"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::warning   {:default         "#F5BD3E"
                :scale-1         "#F5BD3E"
                :scale-2         "#F5BD3E"
                :text-on-color   "#FFFFFF"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}
   ::bg-1      {:default         "#FFFFFF"
                :scale-1         "#FFFFFF"
                :scale-2         "#FFFFFF"
                :text-on-color   "#000000"
                :text-scale-1    "#000000"
                :text-scale-2    "#000000"
                :border-on-color "#000000"
                :border-scale-1  "#000000"
                :border-scale-2  "#000000"}
   ::bg-2      {:default         "#FFFFFF"
                :scale-1         "#FFFFFF"
                :scale-2         "#FFFFFF"
                :text-on-color   "#000000"
                :text-scale-1    "#000000"
                :text-scale-2    "#000000"
                :border-on-color "#000000"
                :border-scale-1  "#000000"
                :border-scale-2  "#000000"}

   ::dimmer    {:default "#000000B2"
                :scale-1 "#00000092"
                :scale-2 "#00000072"}
   ::disabled  {:default         "#CCCCCC"
                :scale-1         "#CCCCCC"
                :scale-2         "#CCCCCC"
                :text-on-color   "#FFFFFF"
                :text-scale-1    "#FFFFFF"
                :text-scale-2    "#FFFFFF"
                :border-on-color "#FFFFFF"
                :border-scale-1  "#FFFFFF"
                :border-scale-2  "#FFFFFF"}})

(def color-keys (keys theme-normal))

(def themes
  {::theme-normal        {:icon    :fa-circle
                          :label   "Light"
                          :palette theme-normal}
   ::theme-dark-mode     {:icon    :fa-moon
                          :label   "Dark"
                          :palette theme-dark-mode}
   ::theme-high-contrast {:icon    :fa-sun
                          :label   "Contrast"
                          :palette theme-high-contrast}})


(def theme (r/atom ::theme-normal))

(defn set-theme
  [t]
  (assert (some #{t} (keys themes)) (str "Unknown theme " t))
  (let [html (.querySelector js/document "html")]
    (.setAttribute html "class" (if (= t ::theme-dark-mode) "dark" "light"))
    (reset! theme t)))

(defn light-mode?
  []
  (= ::theme-normal @theme))

(defn dark-mode?
  []
  (= ::theme-dark-mode @theme))

(defn k->css-border
  [color]
  (get-in themes [@theme :palette color :border-on-color]))


(defn color
  ([default-color]
   (color default-color nil false))
  ([default-color override-color]
   (color default-color override-color false))
  ([default-color override-color disabled?]
   (when (or (and (keyword? default-color)
                  (not (some #{default-color} color-keys)))
             (and (keyword? override-color)
                  (not (some #{override-color} color-keys))))
     (js/console.warn "Invalid color " default-color " > " override-color))
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :default])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :default])
         (string? override-color)
         override-color
         :else
         (get-in themes [@theme :palette default-color :default]))))

(defn scale-1
  ([default-color]
   (scale-1 default-color nil false))
  ([default-color override-color]
   (scale-1 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :scale-1])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :scale-1])
         (string? override-color)
         (garden/lighten override-color 80)
         :else
         (get-in themes [@theme :palette default-color :scale-1]))))

(defn scale-2
  ([default-color]
   (scale-2 default-color nil false))
  ([default-color override-color]
   (scale-2 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :scale-1])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :scale-1])
         (string? override-color)
         (garden/lighten override-color 60)
         :else
         (get-in themes [@theme :palette default-color :scale-1]))))

(defn text
  ([default-color]
   (text default-color nil false))
  ([default-color override-color]
   (text default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :text-on-color])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :text-on-color])
         (string? override-color)
         override-color
         :else
         (get-in themes [@theme :palette default-color :text-on-color]))))

(defn text-scale-1
  ([default-color]
   (text-scale-1 default-color nil false))
  ([default-color override-color]
   (text-scale-1 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :text-scale-1])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :text-scale-1])
         (string? override-color)
         (garden/lighten override-color 80)
         :else
         (get-in themes [@theme :palette default-color :text-scale-1]))))

(defn text-scale-2
  ([default-color]
   (text-scale-2 default-color nil false))
  ([default-color override-color]
   (text-scale-2 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :text-scale-2])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :text-scale-2])
         (string? override-color)
         (garden/lighten override-color 60)
         :else
         (get-in themes [@theme :palette default-color :text-scale-2]))))

(defn border
  ([default-color]
   (border default-color nil false))
  ([default-color override-color]
   (border default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :border-on-color])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :border-on-color])
         (string? override-color)
         override-color
         :else
         (get-in themes [@theme :palette default-color :border-on-color]))))

(defn border-scale-1
  ([default-color]
   (border-scale-1 default-color nil false))
  ([default-color override-color]
   (border-scale-1 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :border-scale-1])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :border-scale-1])
         (string? override-color)
         (garden/lighten override-color 80)
         :else
         (get-in themes [@theme :palette default-color :border-scale-1]))))

(defn border-scale-2
  ([default-color]
   (border-scale-2 default-color nil false))
  ([default-color override-color]
   (border-scale-2 default-color override-color false))
  ([default-color override-color disabled?]
   (cond disabled?
         (get-in themes [@theme :palette ::disabled :border-scale-2])
         (keyword? override-color)
         (get-in themes [@theme :palette override-color :border-scale-2])
         (string? override-color)
         (garden/lighten override-color 60)
         :else
         (get-in themes [@theme :palette default-color :border-scale-2]))))

